import { Flow_Parameter__Email__Input } from '~/graphql/types';
import { EmailParameterValue } from '~/scenes/Automation/Flows/Actions/Base/types.flow';

import { PARAMETER_VALUE_TYPE } from '../constants';

export default (
  parameterValue: EmailParameterValue,
): Flow_Parameter__Email__Input => {
  switch (parameterValue.type) {
    case PARAMETER_VALUE_TYPE.EMAIL_PRIMITIVE:
      if (parameterValue.value == null) {
        throw new Error(
          `Validation should have caught that the parameterValue ${JSON.stringify(
            parameterValue,
            null,
            2,
          )} value is not identified`,
        );
      }

      return {
        Email: {
          Primitive: {
            value: parameterValue.value,
          },
        },
      };
    case PARAMETER_VALUE_TYPE.EMAIL_POINTER:
      if (
        parameterValue.variable == null ||
        parameterValue.variable.field == null
      ) {
        throw new Error(
          `Validation should have caught that the parameterValue ${JSON.stringify(
            parameterValue,
            null,
            2,
          )} has no field`,
        );
      }

      return {
        Email: {
          Pointer: {
            variable: parameterValue.variable.name,
            field: parameterValue.variable.field.name,
          },
        },
      };
    default:
      throw new Error(
        `Field value input conversion cannot handle (${JSON.stringify(
          parameterValue,
          null,
          2,
        )})`,
      );
  }
};
